app.directive(
    'order', [function(){
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope:{
                'class':'@'
            },
            templateUrl: 'application/templates/directives/order.html',
            link: function(scope, element, attrs){
                element.find('.order-up').bind('click', function() {
                    scope.$emit('orderUp', { 'element' : element } );
                });
                element.find('.order-down').bind('click', function() {
                    scope.$emit('orderDown', { 'element' : element } );
                });
            }
        }
    }]
);
